<template>
  <ca-row>
    <ca-col size="2">
      <ca-button full-width @click="onClose">
        Cancelar
      </ca-button>
    </ca-col>

    <ca-col
      :offset="dropdownOffset"
      size="2">
      <worker-actions-dropdown
        v-if="shouldShowActionsDropdown"
        use-on="rollover"
        :contract-data-status="workerBasicInfo.workflowTask"
        :personal-data="workerBasicInfo.personalData"
        :tab-index="activeTab"
        :is-edit-mode-contract="isEditModeContract"
        :is-edit-mode-personal="isEditModePersonal"
        @on-delete="onDelete"
        @on-edit-contract="onEditContract"
        @on-edit-personal="onEditPersonalData"
        @on-add-personal="onEditPersonalData">
      </worker-actions-dropdown>
    </ca-col>

    <ca-col v-if="shouldShowSaveAndApproveButton" size="2">
      <ca-button
        full-width
        theme="primary"
        :disabled="!isFormValid"
        @click="onSaveAndApprove">
        {{ saveButtonLabel }}
      </ca-button>
    </ca-col>

    <ca-col v-else-if="shouldShowSaveButton" size="2">
      <ca-button
        full-width
        theme="primary"
        :disabled="!isFormValid"
        @click="onSave">
        Salvar
      </ca-button>
    </ca-col>

    <ca-col v-else-if="shouldShowApproveButton" size="2">
      <ca-button
        full-width
        theme="primary"
        @click="onApprove">
        Aprovar
      </ca-button>
    </ca-col>
  </ca-row>
</template>

<script>
import { isUserAccountant } from 'packages/common';
import WorkerActionsDropdown from '../../../components/WorkerActionsDropdown';
import { TABS_INDEX } from '../workerViewRolloverConstants';
import { isStatusPending, isPersonalDataUnregistered } from '../../../../../services/approvalService';
import { shouldShowActionsDropdown } from '../../../workersService';
import store from '../../../../../store/index';

export default {
  name: 'WorkerViewRolloverFooter',
  components: {
    WorkerActionsDropdown,
  },
  props: {
    activeTab: Number,
    isEditModeContract: Boolean,
    isEditModePersonal: Boolean,
    contractData: Object,
    isFormValid: Boolean,
  },
  computed: {
    workerBasicInfo() {
      return store.state.worker.basicInfo;
    },
    shouldShowActionsDropdown() {
      return shouldShowActionsDropdown(this.workerBasicInfo);
    },
    shouldShowSaveButton() {
      return (this.isEditModeContract && this.activeTab === TABS_INDEX.CONTRACT)
      || (this.isEditModePersonal && this.activeTab === TABS_INDEX.PERSONAL);
    },
    shouldShowApproveButton() {
      return isUserAccountant() && ((
        this.activeTab === TABS_INDEX.CONTRACT
        && isStatusPending(this.workerBasicInfo.workflowTask)
      ) || (
        this.activeTab === TABS_INDEX.PERSONAL
        && (
          isStatusPending(this.workerBasicInfo.personalData?.workflowTask)
          || isPersonalDataUnregistered(this.workerBasicInfo)
        )
      ));
    },
    shouldShowSaveAndApproveButton() {
      return this.shouldShowSaveButton && this.shouldShowApproveButton;
    },
    saveButtonLabel() {
      return isUserAccountant()
        && (
          isStatusPending(this.workerBasicInfo.workflowTask)
          || isStatusPending(this.workerBasicInfo.personalData?.workflowTask)
        ) ? 'Salvar e Aprovar' : 'Salvar';
    },
    dropdownOffset() {
      return this.shouldShowApproveButton || this.shouldShowSaveButton ? 6 : 8;
    },
  },
  watch: {
    contractData: {
      deep: true,
      handler() {
      },
    },
    personalData: {
      deep: true,
      handler() {
      },
    },
  },
  methods: {
    onDelete() {
      this.$emit('on-delete');
    },
    onEditContract() {
      this.$emit('edit-contract-data');
    },
    onEditPersonalData() {
      this.$emit('edit-personal-data');
    },
    onClose() {
      this.$emit('on-close');
    },
    onSave() {
      this.$emit('on-save');
    },
    onApprove() {
      this.$emit('on-approve');
    },
    onSaveAndApprove() {
      this.$emit('on-save-and-approve');
    },
  },
};
</script>
